import {
    EstabCaracterizacaoGeralModel,
    IAtividadeSecundaria,
    IConvenio,
    IEstabCaracterizacaoGeral,
    IHorarioAtendimento,
    INivelAtencao
} from './estab-caracterizacao-geral.model';
import {EstabSevicoModel, IEstabSevico} from './estab-sevico.model';
import {EstabMarcacaoModel} from './estab-marcacao.model';
import {CaracterizacaoGeral, Rascunho} from '../../rascunho';
import {Guid} from 'guid-typescript';
import {FiltroBuscaGridModel, ResultadoBuscaGridModel} from '../classes-filtro-busca-grid';
import {EstabLeitoModel} from '../recursos-fisicos/estab-leito.model';

export class CaracterizacaoModulo {
    geral: EstabCaracterizacaoGeralModel;
    servicos: EstabSevicoModel[];
    marcacoes: EstabMarcacaoModel[];
    leitoModel: EstabLeitoModel;

    constructor() {
        this.geral = null;
        this.servicos = [];
        this.marcacoes = [];
    }

    rascunhoParaCaracterizacao(rascunho: any) {
        this.rascunhoParaGeral(rascunho);
        this.rascunhoParaServicos(rascunho);
    }

    rascunhoParaCaracterizacaoGeral(caracterizacaoGeral: any) {
        this.caracterizacaoGeral(caracterizacaoGeral);
        return this.geral;
    }

    async salvarServico(servico: EstabSevicoModel, form: any) {
        servico.idServico = form.idServico ? form.idServico : '';
        servico.servico = form.servico ? form.servico : '';
        servico.servicoObj = form.servicoObj ? form.servicoObj : '';
        servico.idClassificacao = form.idClassificacao ? form.idClassificacao : '';
        servico.classificacao = form.classificacao ? form.classificacao : '';
        servico.classificacaoObj = form.classificacaoObj ? form.classificacaoObj : '';
        servico.idPrestador = form.idPrestador ? form.idPrestador : '';
        servico.prestador = form.prestador ? form.prestador : '';
        servico.cnes = form.cnes ? form.cnes : '';
        servico.nomeFantasia = form.nomeFantasia ? form.nomeFantasia : '';
        servico.idAtendimento = form.idAtendimento ? form.idAtendimento : '';
        servico.atendimento = form.atendimento ? form.atendimento : '';
        servico.atendeSUS = form.atendeSUS ? form.atendeSUS : '';
        const indice = this.servicos.findIndex(objFind => objFind.id === servico.id);
        if (indice >= 0) {
            this.servicos[indice] = servico;
        } else {
            this.servicos.push(servico);
        }
    }

    async excluirServico(servico: EstabSevicoModel) {
        const indice = this.servicos.findIndex(objFind => objFind.id === servico.id);
        this.servicos.splice(indice, 1);
    }

    async syncFormGeral(form: any) {
        /*Object.keys(form).forEach((chave) => {
            this.geral[chave] = form[chave] !== undefined ? form[chave] : '';
        });*/

        // console.log('syncFormGeral: ', form);
        this.geral.grupoAtividadePrincipal = form.grupoAtividadePrincipal ? form.grupoAtividadePrincipal : '';
        this.geral.idGrupoAtividadePrincipal = form.idGrupoAtividadePrincipal ? form.idGrupoAtividadePrincipal : '';
        this.geral.atividadePrincipal = form.atividadePrincipal ? form.atividadePrincipal : '';
        this.geral.idAtividadePrincipal = form.idAtividadePrincipal ? form.idAtividadePrincipal : '';
        this.geral.idTipoEstabelecimento = form.idTipoEstabelecimento ? form.idTipoEstabelecimento : '';
        this.geral.tipoEstabelecimento = form.tipoEstabelecimento ? form.tipoEstabelecimento : '';
        this.geral.possuiContratoSus = form.possuiContratoSus ? form.possuiContratoSus : '';
        this.geral.idFormaAcesso = form.idFormaAcesso ? form.idFormaAcesso : '';
        this.geral.formaAcesso = form.formaAcesso ? form.formaAcesso : '';
        this.geral.sempreAberto = form.sempreAberto ? form.sempreAberto : '';
        this.setHorariosSemana(form);
    }

    setHorariosSemana(form: any) {
        this.geral.horariosAtendimento = [];
        const diasSemana: Array<any> = ['domingo', 'segundafeira', 'tercafeira', 'quartafeira', 'quintafeira', 'sextafeira', 'sabado'];
        diasSemana.forEach((d, index) => {
            if (form[d]) {
                this.geral.horariosAtendimento.push(
                    {
                        codigoDiaSemana: '0' + (index + 1),
                        horarioFim: form[d + 'HrTermino'],
                        horarioInicio: form[d + 'HrInicio']
                    });
            }
        });
    }

    async editarServico(servico: EstabSevicoModel) {
        const indice = this.servicos.findIndex(objFind => objFind.id === servico.id);
        this.servicos[indice] = servico;
    }

    async incluirAtividadeSecundaria(atividade: IAtividadeSecundaria) {
        atividade.id = Guid.create().toString();
        this.geral.atividadesSecundarias.push(atividade);
    }

    async excluirAtividadeSecundaria(atividade: IAtividadeSecundaria) {
        const indice = this.geral.atividadesSecundarias.findIndex(objFind => objFind.id === atividade.id);
        this.geral.atividadesSecundarias.splice(indice, 1);
    }

    async incluirNivelAtencao(nivelAtencao: INivelAtencao) {
        nivelAtencao.id = Guid.create().toString();
        this.geral.niveisAtencao.push(nivelAtencao);
    }

    async excluirNivelAtencao(nivelAtencao: INivelAtencao) {
        const indice = this.geral.niveisAtencao.findIndex(objFind => objFind.id === nivelAtencao.id);
        this.geral.niveisAtencao.splice(indice, 1);
    }

    async incluirConvenio(convenio: IConvenio) {
        convenio.id = Guid.create().toString();
        this.geral.convenios.push(convenio);
    }

    async excluirConvenio(convenio: IConvenio) {
        const indice = this.geral.convenios.findIndex(objFind => objFind.id === convenio.id);
        this.geral.convenios.splice(indice, 1);
    }

    async buscarServicos(filtros: FiltroBuscaGridModel): Promise<ResultadoBuscaGridModel> {
        let listaOriginal: EstabSevicoModel[] = [];
        if (this.servicos && this.servicos.length) {
            if (filtros.textoBuscaTextual.length > 1) {
                listaOriginal = this.servicos.filter(p =>
                    p.classificacao.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.servico.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase())
                );
            } else {
                listaOriginal = this.servicos;
            }
        }
        return new ResultadoBuscaGridModel(filtros, listaOriginal);
    }

    private rascunhoParaGeral(rascunho: any) {
        const geral: IEstabCaracterizacaoGeral = {
            // tslint:disable-next-line:max-line-length
            grupoAtividadePrincipal: rascunho.atividades ? rascunho.atividades.atividadePrincipal ? rascunho.atividades.atividadePrincipal.grupo ? rascunho.atividades.atividadePrincipal.grupo.descricao : '' : '' : '',
            // tslint:disable-next-line:max-line-length
            idGrupoAtividadePrincipal: rascunho.atividades ? rascunho.atividades.atividadePrincipal ? rascunho.atividades.atividadePrincipal.grupo ? rascunho.atividades.atividadePrincipal.grupo.codigo : '' : '' : '',
            // tslint:disable-next-line:max-line-length
            atividadePrincipal: rascunho.atividades ? rascunho.atividades.atividadePrincipal ? rascunho.atividades.atividadePrincipal.descricao : '' : '',
            // tslint:disable-next-line:max-line-length
            idAtividadePrincipal: rascunho.atividades ? rascunho.atividades.atividadePrincipal ? rascunho.atividades.atividadePrincipal.codigo : '' : '',
            // tslint:disable-next-line:max-line-length
            idTipoEstabelecimento: rascunho.estabelecimentoSaude ? rascunho.estabelecimentoSaude.tipoEstabelecimento : '', // tipoEstabelecimento.codigo,
            tipoEstabelecimento: null, // TODO Descrição Tipo Estabelecimento (Caracterização Geral) tipoEstabelecimento.descricao,
            possuiContratoSus: null, // TODO Possui o SUS (Caracterização Geral)
            idFormaAcesso: null, // TODO Código Forma Acesso (Caracterização Geral)
            formaAcesso: null, // TODO Descrição Forma Acesso (Caracterização Geral)
            sempreAberto: null, // TODO Sempre Aberto (Caracterização Geral) Verificar dias da semana na lista de horários de atendimento
            atividadesSecundarias: this.rascunhoParaAtividadesSecundarias(rascunho),
            niveisAtencao: this.rascunhoParaNiveisAtencao(rascunho),
            convenios: this.rascunhoParaConvenios(rascunho),
            horariosAtendimento: this.rascunhoParaHorariosAtendimento(rascunho),
        };
        this.geral = geral;
    }

    private rascunhoParaAtividadesSecundarias(rascunho: Rascunho): IAtividadeSecundaria[] {
        const lista: IAtividadeSecundaria[] = [];
        if (rascunho.atividades && rascunho.atividades.atividadesSecundarias && rascunho.atividades.atividadesSecundarias.length > 0) {
            rascunho.atividades.atividadesSecundarias.forEach((item) => {
                const atividadeSecundaria: IAtividadeSecundaria = {
                    id: Guid.create().toString(),
                    idAtividade: item.codigo,
                    descricaoAtividade: item.descricao,
                    idGrupoAtividade: item.grupo ? item.grupo.codigo : '',
                    descricaoGrupoAtividade: item.grupo ? item.grupo.descricao : '',
                };
                lista.push(atividadeSecundaria);
            });
        }
        return lista;
    }

    private rascunhoParaNiveisAtencao(rascunho: Rascunho): INivelAtencao[] {
        const lista: INivelAtencao[] = [];
        if (rascunho.niveisAtencao && rascunho.niveisAtencao.length > 0) {
            rascunho.niveisAtencao.forEach((item) => {
                const nivelAtencao: INivelAtencao = {
                    id: Guid.create().toString(),
                    idGestao: item.gestao,
                    descricaoGestao: '', // TODO Buscar no domínio (Nível de Atenção) - Pedir para o maurício
                    idComplexidade: item.nivelAtencao ? item.nivelAtencaoObj.codigo : '', // Nível de Atenção
                    descricaoComplexidade: item.nivelAtencao ? item.nivelAtencaoObj.descricao : '',  // Nível de Atenção
                    idTipo: '', // TODO Código Tipo (Nível de Atenção)
                    descricaoTipo: '', // TODO Descrição Tipo (Nível de Atenção)
                };
                lista.push(nivelAtencao);
            });
        }
        return lista;
    }

    private rascunhoParaConvenios(rascunho: Rascunho): IConvenio[] {
        const lista: IConvenio[] = [];
        if (rascunho.convenios && rascunho.convenios.length > 0) {
            rascunho.convenios.forEach((item) => {
                const convenio: IConvenio = {
                    id: Guid.create().toString(),
                    idConvenio: item.convenioObj ? item.convenioObj.codigo : '',
                    descricaoConvenio: item.convenioObj ? item.convenioObj.descricao : '',
                    // idAtendimento: item.atendimentoObj ? item.atendimentoObj.codigo : '',
                    // descricaoAtendimento: item.atendimentoObj ? item.atendimentoObj.descricao : '',
                };
                lista.push(convenio);
            });
        }
        return lista;
    }

    private rascunhoParaHorariosAtendimento(rascunho: Rascunho): IHorarioAtendimento[] {
        const lista: IHorarioAtendimento[] = [];

        if (rascunho.horarioAtendimento && rascunho.horarioAtendimento.length > 0) {
            rascunho.horarioAtendimento.forEach((item) => {
                const horarioAtendimento: IHorarioAtendimento = {
                    horarioFim: item.horarioFim, // "18:00"
                    horarioInicio: item.horarioInicio, // "08:00"
                    codigoDiaSemana: item.codigoDiaSemana,
                };
                lista.push(horarioAtendimento);
            });
        }
        return lista;
    }

    private rascunhoParaServicos(rascunho: any) {
        if (rascunho.servicosEspecializados && rascunho.servicosEspecializados.length > 0) {
            rascunho.servicosEspecializados.forEach((item) => {
                const servico: IEstabSevico = {
                    id: Guid.create().toString(),
                    idServico: item.servicoEspecializado ? item.servicoEspecializado.id : '',
                    servico: item.servicoEspecializado ? item.servicoEspecializado.descricao : '',
                    servicoObj: item.servicoEspecializado,
                    idClassificacao: item.classificacaoServico ? item.classificacaoServico.id : '',
                    classificacao: item.classificacaoServico ? item.classificacaoServico.descricao : '',
                    classificacaoObj: item.classificacaoServico,
                    idPrestador: item.codigoPrestador ? item.codigoPrestador : '',
                    prestador: item.descricaoPrestador ? item.descricaoPrestador : '',
                    cnes: item.cnes,
                    nomeFantasia: null,
                    idAtendimento: item.idAtendimento,
                    atendimento: item.atendimento,
                    atendeSUS: item.atendeSUS,
                };
                this.servicos.push(new EstabSevicoModel(servico));
            });
        }
    }

    private caracterizacaoGeral(rascunhoGeral: any) {
        const atividadePrincipal = rascunhoGeral.classificacaoTipoEstabelecimento.atividadePrincipal;
        const atividadesSecundarias = rascunhoGeral.classificacaoTipoEstabelecimento.atividadesSecundarias;

        const geral: IEstabCaracterizacaoGeral = {
            // tslint:disable-next-line:max-line-length
            grupoAtividadePrincipal: atividadePrincipal ? atividadePrincipal.grupo ? atividadePrincipal.grupo.descricao : '' : '',
            // tslint:disable-next-line:max-line-length
            idGrupoAtividadePrincipal: atividadePrincipal ? atividadePrincipal.grupo ? atividadePrincipal.grupo.codigo : '' : '',
            atividadePrincipal: atividadePrincipal ? atividadePrincipal.descricao : '',
            idAtividadePrincipal: atividadePrincipal ? atividadePrincipal.codigo : '',
            // tslint:disable-next-line:max-line-length
            idTipoEstabelecimento: rascunhoGeral.classificacaoTipoEstabelecimento.tipoEstabelecimento ? rascunhoGeral.classificacaoTipoEstabelecimento.tipoEstabelecimento.codigo : '', // tipoEstabelecimento.codigo,
            // tslint:disable-next-line:max-line-length
            tipoEstabelecimento: rascunhoGeral.classificacaoTipoEstabelecimento.tipoEstabelecimento ? rascunhoGeral.classificacaoTipoEstabelecimento.tipoEstabelecimento.descricao : '',
            possuiContratoSus: rascunhoGeral.contratoSUS,
            idFormaAcesso: rascunhoGeral.formaAcesso ? rascunhoGeral.formaAcesso.codigo : '',
            formaAcesso: rascunhoGeral.formaAcesso ? rascunhoGeral.formaAcesso.descricao : '',
            sempreAberto: rascunhoGeral.sempreAberto,
            atividadesSecundarias: this.rascunhoGeralParaAtividadesSecundarias(rascunhoGeral.classificacaoTipoEstabelecimento),
            niveisAtencao: this.rascunhoGeralParaNiveisAtencao(rascunhoGeral),
            convenios: this.rascunhoGeralParaConvenios(rascunhoGeral),
            horariosAtendimento: this.rascunhoGeralParaHorariosAtendimento(rascunhoGeral),
        };
        this.geral = geral;
    }

    private rascunhoGeralParaAtividadesSecundarias(rascunhoGeral: CaracterizacaoGeral): IAtividadeSecundaria[] {
        const lista: IAtividadeSecundaria[] = [];
        if (rascunhoGeral.atividadesSecundarias && rascunhoGeral.atividadesSecundarias.length > 0) {
            rascunhoGeral.atividadesSecundarias.forEach((item) => {
                const atividadeSecundaria: IAtividadeSecundaria = {
                    id: Guid.create().toString(),
                    idAtividade: item.codigo,
                    descricaoAtividade: item.descricao,
                    idGrupoAtividade: item.grupo ? item.grupo.codigo : '',
                    descricaoGrupoAtividade: item.grupo ? item.grupo.descricao : '',
                };
                lista.push(atividadeSecundaria);
            });
        }
        return lista;
    }

    private rascunhoGeralParaNiveisAtencao(rascunhoGeral: CaracterizacaoGeral): INivelAtencao[] {
        const lista: INivelAtencao[] = [];
        if (rascunhoGeral.niveisAtencao && rascunhoGeral.niveisAtencao.length > 0) {
            rascunhoGeral.niveisAtencao.forEach((item) => {
                const nivelAtencao: INivelAtencao = {
                    id: Guid.create().toString(),
                    idGestao: item.tipoGestao.codigo,
                    descricaoGestao: item.tipoGestao.descricao,
                    idComplexidade: item.gestao.codigo, // Nível de Atenção
                    descricaoComplexidade: item.gestao.descricao,  // Nível de Atenção
                    idTipo: item.gestao.tipoAtividade.codigo,
                    descricaoTipo: item.gestao.tipoAtividade.descricao,
                };
                lista.push(nivelAtencao);
            });
        }
        return lista;
    }

    private rascunhoGeralParaConvenios(rascunhoGeral: CaracterizacaoGeral): IConvenio[] {
        const lista: IConvenio[] = [];
        if (rascunhoGeral.convenios && rascunhoGeral.convenios.length > 0) {
            rascunhoGeral.convenios.forEach((item) => {
                const convenio: IConvenio = {
                    id: Guid.create().toString(),
                    idConvenio: item.codigo,
                    descricaoConvenio: item.descricao,
                    // idAtendimento: item.atendimentoObj ? item.atendimentoObj.codigo : '',
                    // descricaoAtendimento: item.atendimentoObj ? item.atendimentoObj.descricao : '',
                };
                lista.push(convenio);
            });
        }
        return lista;
    }

    private rascunhoGeralParaHorariosAtendimento(rascunhoGeral: CaracterizacaoGeral): IHorarioAtendimento[] {
        const lista: IHorarioAtendimento[] = [];

        if (rascunhoGeral.horariosAtendimento && rascunhoGeral.horariosAtendimento.length > 0) {
            rascunhoGeral.horariosAtendimento.forEach((item) => {
                const horarioAtendimento: IHorarioAtendimento = {
                    horarioFim: item.horarioFim, // "18:00"
                    horarioInicio: item.horarioInicio, // "08:00"
                    codigoDiaSemana: item.diaSemana.codigo,
                };
                lista.push(horarioAtendimento);
            });
        }
        return lista;
    }
}
